import { useEventListener } from "@vueuse/core";

// Scrive in `--app-height` l'altezza reale della finestra (su telefono 100vh include la barra del browser). Si usa una volta nel layout.
export function useAltezzaApp(): void {
  const aggiorna = () => document.documentElement.style.setProperty("--app-height", `${window.innerHeight}px`);
  onMounted(aggiorna);
  useEventListener(import.meta.client ? window : undefined, "resize", aggiorna);
}
